/** @format */

import { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Search } from '../search';
import useQuery from 'src/hooks/useQuery';
import { useTranslation } from 'react-i18next';

export const TicketSearch = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const query = useQuery().get('query');
  const [keyword, setKeyword] = useState(query ? query : '');

  const onSubmit = () => {
    if (keyword) history.push(`/mycompanycases/search/?query=${encodeURI(keyword)}`);
    else history.push(`/mycompanycases`);
  };

  return <Search keyword={keyword} onChange={e => setKeyword(e.target.value)} onSubmit={onSubmit} />;
};
